import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { getContentLanguagesHash } from './actions';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [getContentLanguagesHash]: {
    next: (state: State.ContentLanguages, action: any): State.ContentLanguages => ({
      ...state,
      contentLanguagesHash: action.payload,
      contentLanguagesFetched: true,
    }),

    throw: (state: State.ContentLanguages, action: any): State.ContentLanguages => ({
      ...state,
      error: action.payload,
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
